/**
 * RAG-31 — Correspondance entre un code marque externe (Interactiv) et une marque Ragues.
 */
export class BrandMapping {
  id: number;
  source: string;
  external_code: string;
  external_label: string | null;
  brand_id: string | null;
  brand: { id: string; name: string } | null;
  origin: string;
  author: { id: number; email: string } | null;
  products_count: number;
  updated_at: string | null;

  constructor(data: any) {
    this.id = data.id;
    this.source = data.source;
    this.external_code = data.external_code;
    this.external_label = data.external_label ?? null;
    this.brand_id = data.brand_id ?? null;
    this.brand = data.brand ?? null;
    this.origin = data.origin;
    this.author = data.author ?? null;
    this.products_count = data.products_count ?? 0;
    this.updated_at = data.updated_at ?? null;
  }

  get externalLabel(): string {
    return this.external_label ?? this.external_code;
  }
}
